// The payrun engine creates a separate "Default <category>" band per OT
// category (e.g. "Default Week Off", "Default Holiday") whenever an employee
// isn't mapped to a configured band for that category, on top of the plain
// "Default Band" used for regular overtime. All of these are the same
// unconfigured/factor-1 band, so every screen that prints a raw band name
// should read just "Default Band" regardless of which category produced it.
const DEFAULT_BAND_NAME_PATTERN = /^Default\s+(?:Week\s*Off|Holiday)\b/i;

export const normalizeBandName = (bandName) =>
  typeof bandName === "string" && DEFAULT_BAND_NAME_PATTERN.test(bandName.trim())
    ? "Default Band"
    : bandName;
